import { formatScoreScaledToDisplay } from 'modules/analyse/utils/formatScoreScaledToDisplay';
import { isNumber } from 'utils/validation';

export const getScoreScaleFormatter = (score: number | null | undefined) => {
  return isNumber(score) ? formatScoreScaledToDisplay(score as number) : '';
};
